import {ErrorsInterface} from './errors-stan.interface'

export const errorsStanPoczatkowy: ErrorsInterface = {
  errors: null
}
